import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

import { store, RootState } from '../store';
import { EnvironmentConfig } from '../../utils/config/environment.config';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { CryptoHelper } from '../../utils/helpers/crypto.helper';

//NOTA: ESTO AGREGUE PORQUE NO PODIA ACCEDER A MANUFACTURING CON LOS PARAMETROS
export const manufacturingAxiosApiService = () => {
  const instance = axios.create({
    baseURL: `${EnvironmentConfig.apiUrlManufacturingRoute}/api`,
    headers: {
      'Access-Control-Allow-Origin': EnvironmentConfig.frontendUrl,
      'Access-Control-Allow-Headers':
        'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method',
      'Content-Type': 'application/json',
    },
  });

  const headers = instance.defaults.headers;

  const storedToken = localStorage.getItem('token');
  if (storedToken) {
    const decryptedToken: string = CryptoHelper.decrypt(storedToken);
    headers.common['Authorization'] = `Bearer ${decryptedToken}`;
  }

  const handleError = async (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      const state: RootState = store.getState();
      state.auth = {
        events: null,
        menu: null,
        token: null,
        user: null,
        roles: null,
      };
      window.location.reload();
    }
    return Promise.reject(error);
  };

  instance.interceptors.request.use(
    async (config: any | AxiosRequestConfig) => {
      /* your logic here */
      return config;
    },
  );

  instance.interceptors.response.use((response) => response, handleError);

  return instance;
};

const baseQuery = fetchBaseQuery({
  baseUrl: `${EnvironmentConfig.apiUrlManufacturingRoute}/api`,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    headers.set('Access-Control-Allow-Origin', EnvironmentConfig.frontendUrl);
    headers.set(
      'Access-Control-Allow-Header',
      'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method',
    );
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    localStorage.clear();
    const state: RootState = store.getState();
    state.auth = {
      events: null,
      menu: null,
      token: null,
      user: null,
      roles: null,
    };
    window.location.reload();
  }
  return result;
};

export const manufacturingRouteApi = createApi({
  reducerPath: 'mr-api',
  baseQuery: baseQueryWithReauth,
  // Aquí vas sumando los módulos que quieres que tengan auto-refresco
  tagTypes: [
    'TypeMaterial',
    'LoadMaterial',
    'Resources',
    'ResourceSpeedTrefilado',
    'ResourceSpeedVarilla',
    'ResourceSpeedPlastificado',
    'ResourceSpeedAlambreGalvanizado',
    'SheetSkuOlimpica',
    'SheetSkuPlastificado',
    'RequestDashboard',
  ],
  endpoints: () => ({}),
});
